import React from 'react';
import ChangePassword from '../pages/ChangePassword';

export const changePasswordRoutePage = {
  component: <ChangePassword />,
  route: '/alterar-senha',
};
